import { CardBody } from '@statsbomb/kitbag-components';
import { PlaylistEntry } from '@statsbomb/video-client-js';
import { useTranslation } from 'react-i18next';
import { VideoPlayer } from './VideoPlayer';

export const VideoPlayerPanelBodyBase = ({
  videoEvents,
  unavailableVideosCount,
  isLoading = false,
}: {
  videoEvents: PlaylistEntry[];
  unavailableVideosCount?: number;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation('status');
  const statusProps = isLoading
    ? {
        statusType: 'loading',
        statusTitle: t('general.loading.title'),
        statusDescription: t('general.loading.description'),
      }
    : {};

  return (
    <CardBody {...statusProps}>
      <VideoPlayer videoEvents={videoEvents} unavailableVideosCount={unavailableVideosCount} />
    </CardBody>
  );
};
